
import React, { createContext, useContext, ReactNode } from 'react';

// Контекст для отключения определенных хуков на страницах администратора
interface DisableHooksContextType {
  disableCourierHooks: boolean;
}

const DisableHooksContext = createContext<DisableHooksContextType>({
  disableCourierHooks: false,
});

interface DisableHooksProviderProps {
  children: ReactNode;
  disableCourierHooks?: boolean;
}

export const DisableHooksProvider: React.FC<DisableHooksProviderProps> = ({
  children,
  disableCourierHooks = false,
}) => {
  return (
    <DisableHooksContext.Provider value={{ disableCourierHooks }}>
      {children}
    </DisableHooksContext.Provider>
  );
};

export const useDisableHooks = () => useContext(DisableHooksContext);

export default DisableHooksContext;
